import * as Types from '../../../graphql.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetSmartphoneFamiliesSlugAndFlagshipQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetSmartphoneFamiliesSlugAndFlagshipQuery = { __typename?: 'query_root', b2CSmartphoneCatalog?: Types.Maybe<{ __typename?: 'B2CSmartphoneCatalogEntityResponse', data?: Types.Maybe<{ __typename?: 'B2CSmartphoneCatalogEntity', attributes?: Types.Maybe<{ __typename?: 'B2CSmartphoneCatalog', catalogId: string, entries?: Types.Maybe<Array<Types.Maybe<{ __typename?: 'ComponentEntriesSmartphoneEntry', subscriptions?: Types.Maybe<{ __typename?: 'SmartphoneSubscriptionRelationResponseCollection', data: Array<{ __typename?: 'SmartphoneSubscriptionEntity', attributes?: Types.Maybe<{ __typename?: 'SmartphoneSubscription', subscriptionItem?: Types.Maybe<{ __typename?: 'items', stock?: Types.Maybe<{ __typename?: 'devices_stock_view_cache', isOnline?: Types.Maybe<boolean> }> }>, smartphoneVariant?: Types.Maybe<{ __typename?: 'SmartphoneVariantEntityResponse', data?: Types.Maybe<{ __typename?: 'SmartphoneVariantEntity', attributes?: Types.Maybe<{ __typename?: 'SmartphoneVariant', slug: string }> }> }> }> }> }>, flagship?: Types.Maybe<{ __typename?: 'SmartphoneSubscriptionEntityResponse', data?: Types.Maybe<{ __typename?: 'SmartphoneSubscriptionEntity', attributes?: Types.Maybe<{ __typename?: 'SmartphoneSubscription', subscriptionItem?: Types.Maybe<{ __typename?: 'items', stock?: Types.Maybe<{ __typename?: 'devices_stock_view_cache', isOnline?: Types.Maybe<boolean> }> }>, smartphoneVariant?: Types.Maybe<{ __typename?: 'SmartphoneVariantEntityResponse', data?: Types.Maybe<{ __typename?: 'SmartphoneVariantEntity', attributes?: Types.Maybe<{ __typename?: 'SmartphoneVariant', slug: string, smartphoneFamily?: Types.Maybe<{ __typename?: 'SmartphoneFamilyEntityResponse', data?: Types.Maybe<{ __typename?: 'SmartphoneFamilyEntity', attributes?: Types.Maybe<{ __typename?: 'SmartphoneFamily', slug: string }> }> }> }> }> }> }> }> }> }>>> }> }> }> };


export const GetSmartphoneFamiliesSlugAndFlagshipDocument = gql`
    query GetSmartphoneFamiliesSlugAndFlagship {
  b2CSmartphoneCatalog {
    data {
      attributes {
        catalogId
        entries {
          subscriptions {
            data {
              attributes {
                subscriptionItem {
                  stock {
                    isOnline: is_online
                  }
                }
                smartphoneVariant {
                  data {
                    attributes {
                      slug
                    }
                  }
                }
              }
            }
          }
          flagship {
            data {
              attributes {
                subscriptionItem {
                  stock {
                    isOnline: is_online
                  }
                }
                smartphoneVariant {
                  data {
                    attributes {
                      slug
                      smartphoneFamily {
                        data {
                          attributes {
                            slug
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export function useGetSmartphoneFamiliesSlugAndFlagshipQuery(baseOptions?: Apollo.QueryHookOptions<GetSmartphoneFamiliesSlugAndFlagshipQuery, GetSmartphoneFamiliesSlugAndFlagshipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSmartphoneFamiliesSlugAndFlagshipQuery, GetSmartphoneFamiliesSlugAndFlagshipQueryVariables>(GetSmartphoneFamiliesSlugAndFlagshipDocument, options);
      }
export function useGetSmartphoneFamiliesSlugAndFlagshipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSmartphoneFamiliesSlugAndFlagshipQuery, GetSmartphoneFamiliesSlugAndFlagshipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSmartphoneFamiliesSlugAndFlagshipQuery, GetSmartphoneFamiliesSlugAndFlagshipQueryVariables>(GetSmartphoneFamiliesSlugAndFlagshipDocument, options);
        }
export type GetSmartphoneFamiliesSlugAndFlagshipQueryHookResult = ReturnType<typeof useGetSmartphoneFamiliesSlugAndFlagshipQuery>;
export type GetSmartphoneFamiliesSlugAndFlagshipLazyQueryHookResult = ReturnType<typeof useGetSmartphoneFamiliesSlugAndFlagshipLazyQuery>;
export type GetSmartphoneFamiliesSlugAndFlagshipQueryResult = Apollo.QueryResult<GetSmartphoneFamiliesSlugAndFlagshipQuery, GetSmartphoneFamiliesSlugAndFlagshipQueryVariables>;